import { RootState } from '../index';

const getShiftDetails = (state: RootState) => state.clockReducer.shiftDetails;

const getIsShiftStarted = (state: RootState) => state.clockReducer.isShiftStarted;

const getIsBreakStarted = (state: RootState) => state.clockReducer.isBreakStarted;

const getBreakIndex = (state: RootState) => state.clockReducer.breakIndex;

const getPersonnelStatus = (state: RootState) => state.clockReducer.personnelStatus;

export {
  getShiftDetails,
  getIsShiftStarted,
  getBreakIndex,
  getPersonnelStatus,
  getIsBreakStarted,
};
